import { vestResolver } from '@hookform/resolvers/vest'
import { Button, Checkbox, FormControlLabel, Link, Typography } from '@mui/material'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import colors from '../../../constants/colors'
import CardTAG from '../../CardTAG'
import PasswordInput from '../../PasswordInput'
import TextInput from '../../TextInput'
import FormLayout from '../FormLayout'
import { formTypes, ILoginForm } from './types'
import { formValidation } from './utils'

const defaultValues = { email: '', password: '' }

const LoginForm: React.FC<ILoginForm> = ({ onSubmit }) => {
  const formMethods = useForm<{ [key: string]: string }>({
    defaultValues,
    resolver: vestResolver(formValidation),
    mode: 'onChange',
    shouldFocusError: false,
  })
  const { register, handleSubmit, formState } = formMethods

  const getMessage = useCallback(
    (field: formTypes) => {
      if (!formState.errors[field] || !formState.isSubmitted) return ''

      return formState.errors[field]!.message
    },
    [formState],
  )

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CardTAG title='Log in to TAG Investigator'>
        <Typography
          variant='h4'
          align='center'
          sx={{ marginBottom: '2.8rem', color: colors.TAG_BLUE }}
        >
          Welcome back
        </Typography>
        <FormLayout>
          <TextInput
            register={register}
            fieldName='email'
            label='Email'
            error={getMessage('email')}
          />
          <PasswordInput
            register={register}
            fieldName='password'
            label='Password'
            error={getMessage('password')}
          />
          <FormControlLabel
            control={<Checkbox />}
            label={<Typography variant='boldTextMedium'>Remember Me</Typography>}
          />
          <Button variant='submitFormButton' type='submit'>
            <Typography variant='bodyBold'>Login</Typography>
          </Button>
          <Link href='forgotPassword' underline='none' typography='labelBold'>
            Forgot your password?
          </Link>
        </FormLayout>
      </CardTAG>
    </form>
  )
}

export default LoginForm
